import React, { useEffect, useRef, useState } from "react";
import { Tag, Input, Tooltip, Row, Col } from "antd";
import { compose, withProps } from "recompose";
import {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  Marker,
} from "react-google-maps";

const defaultLocation = { lat: -34.397, lng: 150.644 };

const MapInput = compose<
  any,
  {
    value?: any;
    onChange: any;
    isMobile?: any;
    onUploadClick?: any;
  }
>(
  withProps({
    googleMapURL:
      "https://maps.googleapis.com/maps/api/js?key=AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `290px`, width: `100%` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap
)(({ value, onChange, isMobile }) => {
  const [position, setPosition] = useState(value || defaultLocation);

  useEffect(() => {
    if(value){
      setPosition(value);
    }
  }, [value]);

  return (
    <GoogleMap
      defaultZoom={8}
      center={position}
      onClick={(event) => {
        if(!isMobile){
          value = { lat: event.latLng.lat(), lng: event.latLng.lng() };
          setPosition(value);
          onChange(value);
        }
      }}
    >
      <Marker position={position} />
    </GoogleMap>
  );
});

export default MapInput;
